import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { valueRows } from '../../data/content';
export function ValueTable() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-189" data-mp="34f6nhnvn6cq7">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-190" data-mp="2ze0wbuhmqxis">
        <SectionTag data-id="element-191" data-mp="2zgn0dk5bauw9">Todo incluido</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-192" data-mp="3eazyv3xmk06e">
          Todo lo que incluye tu acceso
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-193" data-mp="3n3v6u5eh89zv">
        <ScrollHintTable minWidth="440px" data-id="element-194" data-mp="3n3bmyj59nbj7">
          <table className="w-full text-left text-sm" data-id="element-195" data-mp="3j1zwkbekim9y">
            <thead data-id="element-196" data-mp="3j3b84xe98ybm">
              <tr className="border-b border-navy/10 bg-navy/5 text-xs uppercase tracking-wide text-navy" data-id="element-197" data-mp="wwmec9qvk2o">
                <th className="px-5 py-3 font-semibold" data-id="element-198" data-mp="3s3g7ck9aoqep">Concepto</th>
                <th className="px-5 py-3 text-right font-semibold" data-id="element-199" data-mp="3s13fnfdqj1og">Incluido</th>
              </tr>
            </thead>
            <tbody data-id="element-200" data-mp="230hf83t9lxzt">
              {valueRows.map(row => <tr key={row.concept} className="border-b border-navy/5" data-id="element-201" data-mp="27xrfkei6zu2f">
                  <td className="px-5 py-4 text-ink" data-id="element-202" data-mp="2cw2n2il0lshh">{row.concept}</td>
                  <td className="whitespace-nowrap px-5 py-4 text-right" data-id="element-203" data-mp="2gxnydzhwhypk">
                    <span className="inline-flex items-center gap-1 font-semibold text-navy" data-id="element-204" data-mp="2gvtcoiyt22kf">
                      <CheckIcon size={14} className="text-orange-hover" data-id="element-205" data-mp="2luwja7ufogui" />
                      Incluido
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}